module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_6-1.8077a841.png";